module.exports = __webpack_public_path__ + "static/media/waiting.8da3f613.svg";